import React, { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useSelector } from 'react-redux';
import Style from '../Styles/DashboardStyle.module.css';
import { Link } from 'react-router-dom';
import constants from "../../services/constants";
import DashboardTitle from "./DashboardTitle";
import DashBoardLeftProfileMenu from "./DashBoardLeftProfileMenu";
import { getUserEventsListFormData,getEventsUserDetailFormData} from "../../services/routes.services";
import { useLocation } from 'react-router-dom';
import ButtonStyle from '../Styles/Button.module.css';
import { Modal,Button } from 'react-bootstrap';

const EventsListing = ()=>{
     const [eventData, setEventData] = useState([]);
     const [eventListData, setEventListData] = useState([]);
       const [showModal, setShowModal] = useState(false);
const [eventListDataNew ,setEventListDataNew] =useState('');
  const handleShow = (data) => {
    setEventListDataNew(data);
    setShowModal(true);
}
  const handleClose = () => setShowModal(false);
     const { token } = useSelector((state) => state.auth);
   const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const status = queryParams.get("status"); // Get the correct param
  
        useEffect(() => {
                getUserEventsListFormData(token)
                .then((res) => {
                    setEventData(res.data.events);
                })

                getEventsUserDetailFormData(token)
                .then((res) => {
                    setEventListData(res.data.bookings);
                })
            },[])
            
    return( 
        <div><DashBoardLeftProfileMenu/>
        {status === "1" ? (
            <div className={'containerStyla  ' + Style.Dashboardscreen +" "+Style.BussinesList}>
                 <Container>  <p>Payment successfull Done.</p>
                  <Link to="/myevent" className={ButtonStyle.greenBtn}>Click Here</Link>
      </Container>
        </div>
      ) : (
      
         <div className={'containerStyla  ' + Style.Dashboardscreen +" "+Style.BussinesList}>
            <Container>
                <DashboardTitle title="My Registered Events" membertype="Non Member" />
                <Row className={Style.space}>
                    <Col lg={6} className={Style.order2}>
                {eventListData && 
                            eventListData.map((eventList)=>{
                                return(
                                   <div >
                                    {eventList?.productinfo?.title && eventList.productinfo.title !== "null" && (
                                        <div className={Style.listCol} key={eventList._id}>
                                        <div className={Style.listDetail}>
                                            

                                            {/* Title Check */}
                                            {eventList?.productinfo?.title && eventList.productinfo.title !== "null" && (
                                            <h4>{eventList.productinfo.title}</h4>
                                            )}

                                        <div className={Style.listOption}>
                                        {/* You can include more details here if needed */}
                                        <p>Amount Paid: ₹{eventList?.amount} {''}</p>
                                        
                                       
                                        </div>
                                         <div className={Style.listOption}>
                                        {/* Link check */}
                                        {eventList?.externalUrl && eventList.externalUrl !== "null" ? (
                                            <Link to={eventList.externalUrl} target="_blank" rel="noopener noreferrer">
                                            More Details
                                            </Link>
                                        ) : (
                                            <Button variant="link" className={Style.detailBtn} onClick={()=>handleShow(eventList)}>
                                                More Details
                                                </Button>
                                        )}
                                        </div>
                                    </div>
                                    </div>
                                    )}
                                    
                                    </div>
        
                                )
                            })
                        }
                        
              
            </Col>
            <Col lg={6} className={Style.order2}>
                {eventData && 
                            eventData.map((eventList)=>{
                                return(
                                    <div className={Style.listCol} key={eventList._id}>
                                        <figure>
                                            <img src={constants.IMAGE_BASE_URL+"/event/"+eventList.image} />
                                        </figure>
                                        <div className={Style.listDetail}>
                                          {eventList.subTitle !=="null" &&  <span>{eventList.subTitle}</span>}
                                           {eventList.title !=="null" && <h4>{eventList.title}</h4>}
                                            <div className={Style.listOption}>
                                                <Link to= {eventList.externalUrl ==="null"?(`/event-detail/${eventList.eventSlug}`):eventList.externalUr}
                                                >More Details</Link>
                                                
                                                {/* <p>{formatDate(eventList.createdAt)}</p> */}
                                            </div>
                                        </div>
                                    </div>           
                                )
                            })
                        }

              
            </Col>
            
         
            </Row>
            </Container>

        </div>
        
      )}
       <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Booking Information</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <p></p>
          <p><strong>Event Title:</strong> {eventListDataNew?.productinfo?.title}</p>
         
          <p><strong>Name:</strong> {eventListDataNew?.userId?.name}</p>
          <p><strong>Email:</strong> {eventListDataNew?.email}</p>
          <p><strong>Phone:</strong> {eventListDataNew?.phone}</p>
          <p><strong>Amount:</strong> ₹{eventListDataNew?.amount}</p>
          <p><strong>Status:</strong> {eventListDataNew?.status}</p>
          <p><strong>Transaction ID:</strong> {eventListDataNew?.txnid}</p>
          <p><strong>Created At:</strong> {new Date(eventListDataNew?.createdAt).toLocaleString()}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Close</Button>
        </Modal.Footer>
      </Modal>
        </div>
        )
    }
    
    export default EventsListing;